// «Ринок → Прогноз ціни». Підхоплюється глобом src/i18n/local/index.ts.
export default {
  nav_market_price_forecast: 'Прогноз ціни',
  ak_nav_price_forecast: 'Прогноз ціни',
  pf_title: 'Прогноз ціни РДН',
  pf_tab_day: 'Доба',
  pf_tab_week: 'Тиждень',
  pf_tab_year: 'Рік (бюджет)',
  pf_prev_day: 'Попередня доба',
  pf_next_day: 'Наступна доба',
  pf_hourly: 'Погодинний прогноз на {{date}}',
  pf_horizon: 'горизонт D+{{h}}',
  pf_horizon_col: 'Горизонт',
  pf_no_forecast: 'На цю добу прогнозу немає. Прогнози зберігаються з 23.10.2026; оберіть пізнішу дату.',
  pf_loading: 'Завантаження…',
  pf_load_error: 'Не вдалося завантажити прогноз.',
  pf_p50: 'Прогноз 50 %',
  pf_corridor: 'Межі 10–90 %',
  pf_p50_legend: 'Прогноз з імовірністю 50 %',
  pf_corridor_legend: 'Межі можливої ціни 10–90 %',
  pf_actual: 'Факт РДН',
  pf_last_year: 'Факт торік',
  pf_uah_mwh: 'грн/МВт·год',
  pf_uah: 'грн',
  pf_mwh: 'МВт·год',
  pf_k_uah: 'тис. грн',
  pf_bess_title: 'Цикл УЗЕ за прогнозом',
  pf_bess_sub: 'УЗЕ Лучок: купуємо {{buy}} МВт·год, продаємо {{sell}} МВт·год — наскрізний ККД {{eff}} % (SOC 18–99 %, заряд ×1,15, розряд ÷1,05, PCS 16 МВт, заряд до розряду)',
  pf_charge: 'Заряд',
  pf_discharge: 'Розряд',
  pf_price_axis: 'Прогноз ціни',
  pf_expected: 'Очікуваний результат',
  pf_realized: 'За фактичними цінами',
  pf_ideal: 'Ідеальний цикл',
  pf_naive_plan: 'Графік «як учора»',
  pf_shortfall: 'Недобір до ідеалу',
  pf_bess_no_cycle: 'За прогнозом спред не покриває втрат циклу — заряджати й розряджати невигідно.',
  pf_bess_wait: 'Факт ще не опубліковано — результат за фактичними цінами зʼявиться після публікації ОРЕЄ (напередодні близько 13:00).',
  pf_acc_title: 'Точність прогнозу ціни',
  pf_acc_rule: 'Точна година — похибка не більше {{rel}} % факту, а якщо це менше {{abs}} грн, то не більше {{abs}} грн',
  pf_acc_hours: 'Точні години',
  pf_of: '{{a}} з {{b}}',
  pf_mae: 'Середня похибка',
  pf_bias: 'Зміщення',
  pf_bias_hint: 'плюс — прогноз вищий за факт',
  pf_in_corridor: 'Факт у коридорі',
  pf_error: 'Похибка (прогноз − факт)',
  pf_accurate: 'Точна',
  pf_inaccurate: 'Неточна',
  pf_acc_wait: 'Факт за цю добу ще не опубліковано — ОРЕЄ публікує результати напередодні близько 13:00.',
  pf_week_title: 'Тиждень вперед',
  pf_date: 'Дата',
  pf_avg: 'Середня',
  pf_minmax: 'Мін – макс',
  pf_cheap: 'Найдешевші',
  pf_dear: 'Найдорожчі',
  pf_year_title: 'Річний прогноз по місяцях',
  pf_year_note: 'Бюджетний прогноз: типова форма доби того ж місяця торік × рівень із трендом останніх 90 діб. Конкретну годину за місяці вперед не прогнозує ніхто — це рівень і коридор, а не обіцянка.',
  pf_month: 'Місяць',
  pf_trend: 'тренд ×{{t}}',
  pf_quality_title: 'Якість моделі на історії',
  pf_quality_sub: 'Бектест за {{days}} діб: прогноз будується лише з даних, відомих на момент подачі, і порівнюється з наївним «та сама година в останню відому добу». Зелене — модель краща за наївний.',
  pf_model: 'Модель',
  pf_naive: 'Наївний',
  pf_bess_90: 'УЗЕ за {{days}} діб, % ідеалу',
  pf_band: 'Коридор: покриття · ширина',
  pf_quality_note: 'Як читати: цикл УЗЕ майже щодня має однакову форму (дешевий день, дорогий вечір), тож і наївний прогноз бере 90 %+ ідеалу. Важить різниця з наївним у гривнях, а не сама частка. Покриття коридору без ширини нічого не означає: широкий коридор накриває будь-що.',
  pf_old_run: 'Метрики цього прогону пораховані за старою методикою — оновляться з наступним прогоном.',
} as Record<string, string>;
